// extracted by mini-css-extract-plugin
export default {"miaInput":"Input_miaInput__oy9UP","error":"Input_error__lnaZe"};